import { render } from "./MainDashiew.vue?vue&type=template&id=03b92c1f&scoped=true"
import script from "./MainDashiew.vue?vue&type=script&lang=js"
export * from "./MainDashiew.vue?vue&type=script&lang=js"

import "./MainDashiew.vue?vue&type=style&index=0&id=03b92c1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b92c1f"]])

export default __exports__